import { render } from "./404.vue?vue&type=template&id=297ff93a"
const script = {}
script.render = render

export default script